import { Box, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import styles from '../Dashboard.module.scss';
import { useEffect, useRef } from 'react';
import { useResponsiveValue } from '~/hooks/useResponsiveValue';
import { INewAccounts } from '~/utils/interface/dashboard';
const cx = classNames.bind(styles);

type CustomBarLabelProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  value: number;
  fontSize?: number;
};

const CustomBarLabel = (props: CustomBarLabelProps) => {
  const { x, y, width, value, fontSize } = props;
  const newY = y + 20;

  return (
    <text x={x + width / 2} y={newY} fill='#fff' textAnchor='middle' alignmentBaseline='middle' fontSize={fontSize}>
      {value}
    </text>
  );
};
const NewUsers = (props: { newUsers: INewAccounts[] }) => {
  const { t } = useTranslation('admin/home');
  const maxValue = Math.max(...props.newUsers.map((d) => d.Count));
  const step = 20;
  const maxTick = Math.ceil(maxValue / step) * step;
  const ticks = Array.from({ length: maxTick / step + 1 }, (_, i) => i * step);

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const responsive = useResponsiveValue({
    lg: {
      barWidth: 30,
      gapWidth: 10,
      height: 300,
      fontSize: 10,
    },
    xl: {
      barWidth: 45,
      gapWidth: 30,
      height: 380,
      fontSize: 12,
    },
  });

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollLeft = container.scrollWidth;
    }
  }, []);
  return (
    <Box className={cx('w-[28%] h-full', 'dashboard-widget')}>
      <Typography className={cx('dashboard-widget-title', 'dashboard-widget-title-text')}>{t('newUser')}</Typography>
      <Box className={cx('dashboard-widget-body')}>
        <Box className={cx('!overflow-x-auto pt-5')} ref={scrollContainerRef}>
          <BarChart
            width={props.newUsers.length * ((responsive?.barWidth ?? 45) + (responsive?.gapWidth ?? 30)) + 80}
            height={responsive?.height}
            data={props.newUsers}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barGap={responsive?.gapWidth ?? 30}
            barSize={responsive?.barWidth ?? 45}
          >
            <CartesianGrid strokeDasharray='3 3' horizontal={true} vertical={true} />
            <XAxis
              dataKey='Month'
              tickLine={false}
              tickFormatter={(value) => `T${value}`}
              fontSize={responsive?.fontSize ?? 12}
            />
            <YAxis domain={[0, maxTick]} ticks={ticks} width={30} fontSize={responsive?.fontSize ?? 12} />

            <Tooltip />
            <Bar
              name={t('count')}
              dataKey='Count'
              fill='#ED1002'
              fillOpacity={0.8}
              background={{ fill: '#eee' }}
              label={(props) => <CustomBarLabel {...props} fontSize={responsive?.fontSize ?? 10} />}
            />
          </BarChart>
        </Box>
        <Box className='flex justify-center mt-3 items-center gap-3'>
          <Box className='lg:w-[7px] xl:w-[10px] lg:h-[7px] xl:h-[10px] bg-[#ED1002]'></Box>
          <Typography className='m-0 lg:text-[10px] xl:text-[12px]'>{t('newUser')}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NewUsers;
